/* eslint-disable no-nested-ternary */

const getImageUrl = (src, params) => {
	if (typeof params === "object" && Object.keys(params).length > 0) {
		const searchParams = new URLSearchParams(params);
		return `${src}?${searchParams.toString()}`;
	}
	return src;
};

export const customLoader1x = (src, type, width, responseWidth, config = {}) => {
	const cfg = config;
	if (type === "image/svg+xml") {
		return src;
	}
	if (width <= responseWidth) {
		return getImageUrl(src, cfg);
	}
	if (width > responseWidth && width < responseWidth * 2) {
		return getImageUrl(src, cfg);
	}
	cfg.w = responseWidth;
	return getImageUrl(src, cfg);
};

export const customLoader2x = (src, type, width, responseWidth, config = {}) => {
	const cfg = config;
	if (type === "image/svg+xml") {
		return src;
	}
	if (width < responseWidth * 2) {
		return null;
	}

	cfg.w = responseWidth * 2;
	return getImageUrl(src, cfg);
};

const mediaSize = (size, src, type, width, xxsSize, config) => {
	const media =
		size && size.minWidth && size.maxWidth
			? {
					minWidth: size.minWidth,
					maxWidth: size.maxWidth,
			  }
			: size && size.minWidth && !size.maxWidth
			? {
					minWidth: size.minWidth,
			  }
			: size && !size.minWidth && size.maxWidth
			? {
					maxWidth: size.maxWidth,
			  }
			: {};

	return {
		src1x: customLoader1x(src, type, width, xxsSize, config),
		src2x: customLoader2x(src, type, width, xxsSize, config),
		...media,
	};
};

const cardBlockConfig = (image, sizes) => {
	const src = `https:${image?.url}`;
	const type = image?.contentType;
	const width = image?.details?.image?.width;

	const { xxsSize, xsSize, smSize, mdSize, lgSize } = sizes;

	return [
		// mediaSize({ maxWidth: 428 }, src, type, width, xxsSize, { fm: "webp" }),
		// mediaSize({ minWidth: 429, maxWidth: 639 }, src, type, width, xsSize, { fm: "webp" }),
		// mediaSize({ minWidth: 640, maxWidth: 767 }, src, type, width, smSize, { fm: "webp" }),
		// mediaSize({ minWidth: 768, maxWidth: 1023 }, src, type, width, mdSize, { fm: "webp" }),
		// mediaSize({ minWidth: 1025 }, src, type, width, lgSize, { fm: "webp" }),

		mediaSize({ maxWidth: 428 }, src, type, width, xxsSize),
		mediaSize({ minWidth: 429, maxWidth: 639 }, src, type, width, xsSize),
		mediaSize({ minWidth: 640, maxWidth: 767 }, src, type, width, smSize),
		mediaSize({ minWidth: 768, maxWidth: 1023 }, src, type, width, mdSize),
		mediaSize({ minWidth: 1025 }, src, type, width, lgSize),
	];
};

export const setRichTextImage = image => {
	const lgSize = 770;
	const mdSize = 652;
	const smSize = 482;
	const xsSize = 619;
	const xxsSize = 408;

	return cardBlockConfig(image, { xxsSize, xsSize, smSize, mdSize, lgSize });
};

export const setFeatureImage = image => {
	const lgSize = 748;
	const mdSize = 630;
	const smSize = 460;
	const xsSize = 619;
	const xxsSize = 408;

	return cardBlockConfig(image, { xxsSize, xsSize, smSize, mdSize, lgSize });
};

export const setBlogCardBlockImage = image => {
	const lgSize = 368;
	const mdSize = 480;
	const smSize = 352;
	const xsSize = 617;
	const xxsSize = 406;

	return cardBlockConfig(image, { xxsSize, xsSize, smSize, mdSize, lgSize });
};

export const setEventsCardBlockImage = image => {
	const lgSize = 368;
	const mdSize = 480;
	const smSize = 352;
	const xsSize = 617;
	const xxsSize = 406;

	return cardBlockConfig(image, { xxsSize, xsSize, smSize, mdSize, lgSize });
};

export const setDefaultCardBlockImage = image => {
	const lgSize = 268;
	const mdSize = 480;
	const smSize = 352;
	const xsSize = 617;
	const xxsSize = 406;

	return cardBlockConfig(image, { xxsSize, xsSize, smSize, mdSize, lgSize });
};
